module.exports = __webpack_public_path__ + "img/3ef26a9.jpg";